import draggable from 'vuedraggable'
import api from '../../services/service'

export default {
  data () {
    return {
      rounds: [],
      listData: [],
      sortListData: [],
      visible: false,
      round_id: '',
      group: {
        group_id: null,
        group_text: ''
      },
      modalGroup: false,
      modalTitle: '',
      group_text: ''
    }
  },
  components: {
    draggable
  },
  methods: {
    getRound () {
      this.$store.state.isLoading = true
      api.getRoundAll(
        result => {
          if (result.result === true) {
            this.rounds = result.data
            this.round_id = result.data[0].round_id
            this.getGroup()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลแบบประเมิน',
              description: 'ไม่มีข้อมูลแบบประเมิน!!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getToken (roundId) {
      var token = ''
      this.rounds.forEach(val => {
        if (roundId === val['round_id']) {
          token = val['round_token']
        }
      })
      return token
    },
    getGroup (value) {
      this.$store.state.isLoading = true
      if (value) {
        this.round_id = value
      }
      api.getMapGroup(
        this.round_id,
        result => {
          if (result.result === true) {
            this.listData = result.data
            this.sortListData = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มคำถาม',
              description: 'ไม่มีข้อมูลกลุ่มคำถาม!!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    delete_group (groupMapID) {
      this.$store.state.isLoading = true
      api.deleteGroup(
        groupMapID,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'ลบกลุ่มคำถามข้อมูล',
              description: result.data
            })
            this.getGroup()
          } else {
            this.$notification['warning']({
              message: 'ลบกลุ่มคำถามข้อมูล',
              description: 'ลบข้อมูลไม่สำเร็จ!!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    handleCancel () {
      this.sortListData = this.listData
    },
    handleOk () {
      this.visible = false
      for (var i = 0; i < this.sortListData.length; i++) {
        this.sortListData[i].map_sort = i + 1
      }
      var obj = {
        qroups: this.sortListData
      }
      api.updateGroupSort(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'ปรับปรุงข้อมูล',
              description: 'ปรับปรุงข้อมูลกลุ่มคำถามเรียบร้อย'
            })
            this.getGroup()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มคำถาม',
              description: 'ไม่มีข้อมูลกลุ่มคำถาม!!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    openGroup (data) {
      this.modalGroup = true
      this.group = data
      if (this.group.group_id) {
        this.modalTitle = 'แก้ไขหมวดคำถาม'
        this.group.group_id = data.group_id
        this.group_text = data.group_text
        this.group.group_text = data.group_text
      } else {
        this.modalTitle = 'เพิ่มหมวดคำถาม'
      }
    },
    reset () {
      this.modalGroup = false
      this.group_text = ''
      this.group.group_id = null
      this.group.group_text = ''
    },
    saveGroup () {
      this.group.group_text = this.group_text
      if (this.group.group_text !== '') {
        if (this.group.group_id) {
          this.editGroup()
        } else {
          this.newGroup()
        }
      }
    },
    newGroup () {
      var obj = {
        round_id: this.round_id,
        group_text: this.group.group_text
      }
      api.addGroup(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'เพิ่มข้อมูล',
              description: 'เพิ่มข้อมูลกลุ่มคำถามเรียบร้อย'
            })
            this.getGroup()
            this.reset()
          } else {
            this.$notification['warning']({
              message: 'เพิ่มข้อมูล',
              description: 'เพิ่มข้อมูลคำถามไม่สำเร็จ!!'
            })
            this.reset()
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          this.reset()
          alert(JSON.stringify(error))
        }
      )
    },
    editGroup () {
      var obj = {
        group_id: this.group.group_id,
        group_text: this.group.group_text
      }
      api.updateGroup(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'แก้ไขข้อมูล',
              description: 'แก้ไขข้อมูลกลุ่มคำถามเรียบร้อย'
            })
            this.getGroup()
            this.reset()
          } else {
            this.$notification['warning']({
              message: 'แก้ไขข้อมูล',
              description: 'แก้ไขข้อมูลคำถามไม่สำเร็จ!!'
            })
            this.reset()
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          this.reset()
          alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.setUser()
    this.getRound()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/groups.js